import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import PatientSlotsTab from './PatientSlotsTab'
import CleaningSlotsTab from './CleaningSlotsTab'
import MaintenanceSlotsTab from './MaintenanceSlotsTab'
import AllSlotsTab from './AllSlotsTab'

export default function SlotsTab ({ slots, boxes, setLoading, updateSlots }) {
  const patientSlots = slots.filter(slot => slot.type === 'PatientSlot')
  const cleaningSlots = slots.filter(slot => slot.type === 'CleaningSlot')
  const maintenanceSlots = slots.filter(slot => slot.type === 'MaintenanceSlot')

  return (
    <Tabs
      defaultActiveKey='patient'
      items={[
        {
          label: t('Admin.SlotsPage.tab.patientSlots'),
          key: 'patient',
          children: <PatientSlotsTab patientSlots={patientSlots} boxes={boxes} setLoading={setLoading} updateSlots={updateSlots} />
        },
        {
          label: t('Admin.SlotsPage.tab.cleaningSlots'),
          key: 'cleaning',
          children: <CleaningSlotsTab cleaningSlots={cleaningSlots} boxes={boxes} setLoading={setLoading} updateSlots={updateSlots} />
        },
        {
          label: t('Admin.SlotsPage.tab.maintenanceSlots'),
          key: 'maintenance',
          children: <MaintenanceSlotsTab maintenanceSlots={maintenanceSlots} boxes={boxes} setLoading={setLoading} updateSlots={updateSlots} />
        },
        {
          label: t('Admin.SlotsPage.tab.allSlots'),
          key: 'all',
          children: <AllSlotsTab slots={slots} boxes={boxes} setLoading={setLoading} updateSlots={updateSlots} />
        }
      ]}
    />
  )
}
